import baseFetch from '../baseFetch';

export const fetchTides = async (lat, lon, bwUnitPreference, countryCode = 'US', userDetails = {}) =>
  baseFetch(`api/forecast/tides?lat=${lat}&lon=${lon}&units=${bwUnitPreference}`, userDetails, {
    headers: {
      'x-geo-country-iso': countryCode,
    },
  });


export const fetchNewTides = async (lat, lon, bwUnitPreference, countryCode = 'US', userDetails = {}) =>
  baseFetch(`tides?lat=${lat}&lon=${lon}&units=${bwUnitPreference}`, userDetails, {
    headers: {
      'x-geo-country-iso': countryCode,
    },
  });



// WEBPACK FOOTER //
// ./src/common/api/tides.js